import React from 'react';
import { Body5, Body7, Container } from '@ui';
import { TransparentFlatButton } from '@ui/buttons';
import { SpecEditorContext } from './SpecEditorContext';
import { TOP_LEVEL_KEYS } from './specSchema';
import { Consequence, MicroLabel, PassiveCard } from './styles';

// Names any top-level key the schema does not know about.
//
// This is the trap the old editor set: the create/update API is lenient and accepts an unknown
// top-level key, so it saves without complaint and lives in the draft's spec_json — and the strict
// compile at lock rejects it (`extra: forbid`). The operator finds out at the one moment nothing
// can be changed.
//
// Nothing is removed automatically. An automatic cleanup would be a write the operator did not
// make, on mount, which would flip the dirty flag on a spec they only opened to read.

export const UnknownRootKeysStrip = () => {
  const { definition, removeValue } = React.useContext(SpecEditorContext);

  const unknown = Object.keys(definition || {}).filter((key) => TOP_LEVEL_KEYS.indexOf(key) === -1);
  if (unknown.length === 0) return null;

  return (
    <PassiveCard as="section" aria-label="Unknown top-level keys">
      <MicroLabel>{`${unknown.length} key${unknown.length === 1 ? '' : 's'} the compile will reject`}</MicroLabel>
      <Container top={6}>
        <Consequence $tone="bad">
          Unknown top-level keys save without complaint and then fail the compile at lock, which is permanent. Remove
          them, or keep them and know that this spec cannot be locked until they are gone.
        </Consequence>
      </Container>
      {unknown.map((key) => (
        <Container key={key} top={16}>
          <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
            <Body5 bold>{key}</Body5>
            <Body7 isLowContrast>{JSON.stringify(definition[key])}</Body7>
            <TransparentFlatButton onClick={() => removeValue(key)}>Remove</TransparentFlatButton>
          </div>
        </Container>
      ))}
    </PassiveCard>
  );
};
